import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

interface IModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowData: any;
}

const mockDataTable1 = [
  {
    id: 1,
    title: 'Date Publsihed',
    data: '20/03/2024',
  },
  {
    id: 2,
    title: 'Tellets Started',
    data: 16,
  },
  {
    id: 3,
    title: 'Tellets Completed',
    data: 10,
  },
  {
    id: 4,
    title: 'Last Tellet',
    data: '21/03/2024',
  },
  {
    id: 5,
    title: 'Tellet Status',
    data: 'Active',
  },
  {
    id: 6,
    title: 'Organization',
    data: 'Org name',
  },
  {
    id: 7,
    title: 'Organization Subscription',
    data: 'Enterprise',
  },
];

function SingleTelletModal({ rowData }: IModalProps) {
  return (
    <Dialog>
      <DialogTrigger>
        <div className="flex items-center gap-3 font-medium hover:underline text-primary">
          {rowData?.name}
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>
            <div className="flex flex-col w-full border-b-2">
              <h2 className="text-xl font-bold text-primary">{rowData?.name}</h2>
              <p className="mb-4 text-[15px] font-normal text-light-gray">
                {rowData?.creator_email}
              </p>
            </div>
          </DialogTitle>
          <div>
            <div className="flex flex-col w-full mt-2">
              {/* actions */}
              <h3 className="text-base font-semibold text-dark-text mb-2.5">Actions</h3>
              <div className="flex gap-6">
                <ul className="flex flex-col gap-1.5 text-sm">
                  <li>
                    <button
                      type="button"
                      className="font-medium underline transition-all ease-in-out hover:text-primary"
                    >
                      Open as workspace admin
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="font-medium underline transition-all ease-in-out hover:text-primary"
                    >
                      Delete Tellet
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="font-medium underline transition-all ease-in-out hover:text-primary"
                    >
                      Pause Tellet
                    </button>
                  </li>
                </ul>
              </div>
              {/* settings */}
              <h3 className="text-base font-semibold text-dark-text mt-6 mb-2.5">Settings</h3>
              <div className="flex flex-col w-fit">
                {mockDataTable1?.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-center text-sm font-medium border text-dark-text"
                  >
                    <div className="py-2 pl-3 w-60">{item.title}</div>
                    <div className="flex items-center justify-center py-1.5 border-l-2 w-44">
                      <p
                        className={cn(
                          'whitespace-nowrap',
                          item?.title === 'Organization' && 'text-primary font-semibold',
                          item?.title === 'Organization Subscription' &&
                            'px-4 text-green-800 w-fit py-px bg-green-200 rounded-full',
                        )}
                      >
                        {item.data}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export default SingleTelletModal;
